import { render } from "./Piano.vue?vue&type=template&id=b46c1498"
import script from "./Piano.vue?vue&type=script&lang=js"
export * from "./Piano.vue?vue&type=script&lang=js"

import "./Piano.vue?vue&type=style&index=0&id=b46c1498&lang=scss"
script.render = render

export default script